import { InfoPanel } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { dashboardRoute, programRequestListRoute, newProgramRequestListRoute, notificationRoute } from "../../routes/routes";

export function StartPage() {
  const { data: userSession } = useGetUserSessionQuery();
  const { t } = useTranslation();
  const history = useHistory();
  if (userSession) {

    if (userSession.roleId === RoleEnum.None) {
      return (
        <>
          <Row>
            <Col md={12}>
              <InfoPanel
                message={t("common.userNoPermisionMessage")}
                color={"danger"}
                fullWidth
              />
            </Col>
          </Row>
        </>
      );
    }
    history.push(notificationRoute());
    return null;
    // else if (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector) {
    //   history.push(dashboardRoute());
    //   return null;
    // }
    // else {
    //   history.push(newProgramRequestListRoute());
    //   return null;
    // }
  }
  else {
    return (
      <>
        <div>{t("common.loadingPageMessage")}</div>
      </>
    );
  }
}
